import { z } from 'zod'

export const balanceSchema = z.object({
  interest: z.number(),
  iof: z.number(),
  ir: z.number(),
  principal: z.number(),
  netAmount: z.number(),
  returnAmount: z.number()
})

export type Balance = z.infer<typeof balanceSchema>

export const ExtendedBalanceSchema = balanceSchema.extend({
  grossAmount: z.number(),
  netInterest: z.number()
})

export type ExtendedBalance = z.infer<typeof ExtendedBalanceSchema>

export const CursorSchema = z.object({
  after: z.string().nullable(),
  before: z.string().nullable(),
  limit: z.number()
})

export type Cursor = z.infer<typeof CursorSchema>

export const EarlyRedemptionConditionSchema = z.object({
  days: z.number(),
  apy: z.string()
})

export type EarlyRedemptionCondition = z.infer<typeof EarlyRedemptionConditionSchema>

export const MarketProductSchema = z.object({
  id: z.string(),
  type: z.string(),
  name: z.string(),
  distributionPartner: z.string(),
  maturityDate: z.string(),
  redemption: z.enum(['early', 'on_maturity']),
  earlyRedemptionConditions: z.array(EarlyRedemptionConditionSchema).nullable(),
  interestIndex: z.enum(['prefixed', 'cdi']),
  interestRateIndex: z.string(),
  interestRatePre: z.string(),
  apy: z.string(),
  accrualPeriodicity: z.enum(['daily', 'monthly']),
  minInvestmentAmount: z.number(),
  maxInvestmentAmount: z.number(),
  maxIndividualLimitAmount: z.number(),
  tags: z.array(z.string()).nullable(),
  fgcInsured: z.boolean(),
  taxRegimen: z.string(),
  riskProfile: z.enum(['low']),
  irRate: z.number().nullable()
})

export type MarketProduct = z.infer<typeof MarketProductSchema>
